"use strict";
// STATE
import { AJAX } from "./helpers.js";
import { SERVER_URL } from "./config.js";
import { PRICE } from "./consts.js";

import makiImg from "../img/maki.jpg";
import temakiImg from "../img/temaki.jpg";
import irodoriImg from "../img/irodori.jpg";
import nigiriImg from "../img/nigiri.jpg";
import inariImg from "../img/inari.jpg";
import inariSpeciaImg from "../img/inarispecial.jpg";

// INIT STATE
export const menuList = {};
export let favorits = new Set();
export let config = {
  isSpecialsFirstPage: false,
  openMenuOnStart: false,
  updated: false,
  activeMenuItems: new Set(),
};

const storage = localStorage.getItem("favorits");
if (storage) favorits = new Set(JSON.parse(storage));

const clearDishes = () => {
  for (let key in map) {
    const category = map[key];

    category.dishes = [];
    if (category.types) {
      category.types.forEach(type => (type.dishes = []));
    }
  }
  console.log("Dishes were cleared");
};

export const sortDishes = (category = undefined) => {
  const compare = (a, b) => {
    let priceA, priceB;
    priceA = Number(Array.isArray(a.price) ? a.price[0] : a.price);
    priceB = Number(Array.isArray(b.price) ? b.price[0] : b.price);
    return priceA - priceB;
  };

  const sortCategories = category => {
    map[category].dishes.sort(compare);

    if (map[category].types) {
      map[category].types.forEach(type => type.dishes.sort(compare));
    }
  };

  if (category) {
    sortCategories(category);
    console.log(`Category ${category} sorted`);
  } else {
    for (let category in map) {
      sortCategories(category);
    }
    console.log("All dishes were sorted");
  }
};

export const pushDishesToState = () => {
  clearDishes();
  createCombitanions();
  createLunch();

  for (let key in menuList) {
    const dish = menuList[key];
    if (dish.deleted) continue;
    if (favorits.has(dish.id) && dish.isActive) {
      dish.isFavorite = true;
      favoritesCount++;
    }
    if (!dish.category) continue;
    map[dish.category].dishes.push(dish);
    if (dish.type || dish.type === 0) {
      map[dish.category].types[dish.type].dishes.push(dish);
    }
    if (dish.isSpecial && dish.category !== "special") {
      map.special.dishes.push(dish);
      if (dish.category === "dessert") map.special.types[1].dishes.push(dish);
      else if (dish.category === "cocktail")
        map.special.types[2].dishes.push(dish);
      else if (
        dish.category === "wineGlass" ||
        dish.category === "wineBottle" ||
        dish.category === "wineCellar"
      ) {
        map.special.types[3].dishes.push(dish);
      } else map.special.types[0].dishes.push(dish);
    }
  }
  sortDishes();
  console.log("Sorted dishes were pushed to the empty state");
};

export let favoritesCount = 0;

export function changeFavoritesCount(operator) {
  if (operator === "+") favoritesCount++;
  if (operator === "-") favoritesCount--;
}

const lunchDescriptionHE = `
    ארוחה עסקית מוגשת בימי חול בלבד א'- ה',<br>
    בין בשעות 12:00-17:00<br>
    ארוחה עסקית כוללת: מנה ראשונה ומנה עיקרית<br>
    בנוסף, כוס יין צהריים לבן / אדום - ${PRICE.LUNCH_DRINK}&nbsp₪`;

const lunchDescriptionEN = `
    Lunch Menu is served from Sunday to Thursday,<br>
    12:00-17:00 (exclude holidays)<br>
    Lunch menu includes: first course & main course<br>
    In addition, wine of the month red / white ${PRICE.LUNCH_DRINK}&nbsp₪`;

export const state = {
  specials: {
    titleHE: "ספיישלים",
    descriptionHE: "",
    titleEN: "Specials",
    descriptionEN: "",
    types: [
      { titleHE: "", titleEN: "", dishes: [] },
      { titleHE: "קינוחים", titleEN: "Desserts", dishes: [] },
      { titleHE: "קוקטיילים", titleEN: "Coctails", dishes: [] },
      { titleHE: "יינות", titleEN: "Wine", dishes: [] },
    ],
    dishes: [],
  },
  appetizers: [
    {
      titleHE: "ראשונות קרות",
      descriptionHE: "",
      titleEN: "Cold Appetizers",
      descriptionEN: "",
      dishes: [],
    },
    {
      titleHE: "ראשונות חמות",
      descriptionHE: "",
      titleEN: "Hot Appetizers",
      descriptionEN: "",
      dishes: [],
    },
  ],
  skewers: {
    titleHE: "שיפודי עץ על הגריל",
    descriptionHE: "",
    titleEN: "Skewers",
    descriptionEN: "",
    dishes: [],
  },
  mainDishes: {
    titleHE: "מנות עיקריות",
    descriptionHE: "",
    titleEN: "Main Dishes",
    descriptionEN: "",
    dishes: [],
  },

  desserts: [
    {
      titleHE: "קינוחים",
      descriptionHE: "",
      titleEN: "Desserts",
      descriptionEN: "",
      dishes: [],
    },
    {
      titleHE: "קפה",
      descriptionHE: "",
      titleEN: "Coffee",
      descriptionEN: "",
      dishes: [],
    },
    {
      titleHE: "תה חליטה",
      descriptionHE: "",
      titleEN: "Infusion Tea",
      descriptionEN: "",
      dishes: [],
    },
    {
      titleHE: "תיונים",
      descriptionHE: "",
      titleEN: "Tea Bags",
      descriptionEN: "",
      dishes: [],
    },
    {
      titleHE: "פורט & שרי",
      descriptionHE: "",
      titleEN: "Port & Sherry",
      descriptionEN: "",
      dishes: [],
    },
  ],
  seshimi: [
    {
      titleHE: "סשימי / ניגירי",
      descriptionHE:
        "סשימי - פילה דג או פרי ים ללא אורז<br> ניגירי - כדור אורז ועליו נתח דג / פרי ים / ירק",

      priceHE: "סשימי/ניגירי",
      titleEN: "Nigiri / Seshimi",
      descriptionEN:
        "Nigiri - rice ball topped with fish or seafood<br>Seshimi - fish or seafood fillet without rice",

      priceEN: "Nigiri/Seshimi",
      imageUrl: nigiriImg,
      dishes: [],
      types: [
        { titleHE: "דגי ים", titleEN: "SEA FISH", dishes: [] },
        { titleHE: "מים מתוקים", titleEN: "SWEET WATER FISH", dishes: [] },
        { titleHE: "פירות ים", titleEN: "SEA FOOD", dishes: [] },
        { titleHE: "שונות", titleEN: "OTHERS", dishes: [] },
        { titleHE: "רק בעונה", titleEN: "ONLY IN SEASON", dishes: [] },
      ],
    },
    {
      titleHE: "סשימי ספיישל",
      descriptionHE: "",

      titleEN: "Seshimi Special",
      descriptionEN: "",

      dishes: [],
    },
  ],
  inari: [
    {
      titleHE: "אינרי / גונקן",
      descriptionHE:
        "אינרי - כיס טופו מתקתק במילוי אורז, דג / פרי ים / ירקות<br>גונקן - כדור אורז עטוף באצה במילוי דג / פרי ים / ירקות",

      priceHE: "אינרי/גונקן",
      titleEN: "Gunkan / Inari",
      descriptionEN:
        "Gunkan - rice ball wrapped with Nori & filled with fish / seafood / vegetables<br>Inari - sweet tofu pocket filled with rice, fish / seafood / vegetables",

      priceEN: "Gunkan/Inari",
      imageUrl: inariImg,
      dishes: [],
    },
    {
      titleHE: "אינארי ספיישל",
      descriptionHE:
        "כדור אורז עטוף אינארי בטמפורה ואצת נורי במילוי דג / פרי ים / ירקות",

      titleEN: "Inari Special",
      descriptionEN: "",

      imageUrl: inariSpeciaImg,
      dishes: [],
    },
  ],

  hosomaki: [
    {
      titleHE: "הוסומקי",
      descriptionHE: "אצת נורי במילוי אורז, דג / פרי ים / ירקות (חתוך ל-8))",

      titleEN: "Hosomaki",
      descriptionEN: "Thin roll (Cut into 8)",

      imageUrl: makiImg,
      dishes: [],
    },
    {
      titleHE: "תוספות אפשריות למאקי",
      descriptionHE: "",

      titleEN: "Optional Ingredients",
      descriptionEN: "",

      dishes: [],
    },
  ],
  temaki: {
    titleHE: "טמקי - קונוס",
    descriptionHE: "קונוס נורי במילוי אורז / דג / פרי ים / ירקות",

    titleEN: "Temaki",
    descriptionEN: "Hand Roll",

    imageUrl: temakiImg,
    dishes: [],
  },
  irodori: [
    {
      titleHE: "אירודורי - IO",
      descriptionHE: "אורז עוטף אצה במילוי ירק / פרי ים / דג (חתוך ל-6)",

      titleEN: "Irodori i/o",
      descriptionEN: "Inside-Out roll - cut into 6",

      imageUrl: irodoriImg,
      dishes: [],
    },
    {
      titleHE: "תוספות אפשריות (בחוץ)",
      descriptionHE: "",

      titleEN: "Optional Ingredients (outside)",
      descriptionEN: "",

      dishes: [],
    },
  ],
  combinations: {
    titleHE: "קומבינציות",
    descriptionHE: "",

    titleEN: "Combinations",
    descriptionEN: "",

    types: [
      {
        titleHE: "צמחונית",
        titleEN: "VEGETARIAN",
        price: PRICE.COMBI_VEGI,
        dishes: [],
        imageUrl: "",
      },
      {
        titleHE: "סקאנה",
        titleEN: "SAKANA",
        price: PRICE.COMBI_SAKANA,
        dishes: [],
        imageUrl: "",
      },
      {
        titleHE: "קאיסן",
        titleEN: "KAISEN",
        price: PRICE.COMBI_KAISEN,
        dishes: [],
        imageUrl: "",
      },
    ],
  },
  lunch: {
    dishes: [],
    titleHE: "רק בעסקיות",
    titleEN: "Lunch only",
    descriptionHE: "",

    descriptionEN: "",
  },
  lunch1: {
    titleHE: `עסקית ${PRICE.LUNCH_1} ₪`,
    descriptionHE: lunchDescriptionHE,

    titleEN: `Lunch ${PRICE.LUNCH_1} ₪`,
    descriptionEN: lunchDescriptionEN,

    types: [
      {
        titleHE: "מנה ראשונה",
        descriptionHE: "",
        titleEN: "FIRST COURSE",
        descriptionEN: "",
        dishes: [],
      },
      {
        titleHE: "מנה עיקרית מהמטבח ",
        descriptionHE: "",
        titleEN: "MAIN COURSE. KITCHEN",
        descriptionEN: "",
        dishes: [],
      },
      {
        titleHE: "מנה עיקרית סושי ",
        descriptionHE:
          "המנה מורכבת מ-3 רולים (רול I/O חתוך ל-6 ומאקי חתוך ל-8) לבחירתך:",
        titleEN: "MAIN COURSE. SUSHI",
        descriptionEN: "Sushi Combination 3 rolls of your choice",
        dishes: [],
      },
    ],
  },
  lunch2: {
    titleHE: `עסקית ${PRICE.LUNCH_2} ₪`,
    descriptionHE: lunchDescriptionHE,

    titleEN: `Lunch ${PRICE.LUNCH_2} ₪`,
    descriptionEN: lunchDescriptionEN,

    types: [
      {
        titleHE: "מנה ראשונה",
        descriptionHE: "",
        titleEN: "FIRST COURSE",
        descriptionEN: "",
        dishes: [],
      },
      {
        titleHE: "מנה עיקרית מהמטבח ",
        descriptionHE: "",
        titleEN: "MAIN COURSE. KITCHEN",
        descriptionEN: "",
        dishes: [],
      },
      {
        titleHE: "מנה עיקרית סושי ",
        descriptionHE:
          "המנה מורכבת מ-3 רולים (רול I/O חתוך ל-6 ומאקי חתוך ל-8) לבחירתך:",
        titleEN: "MAIN COURSE. SUSHI",
        descriptionEN: "Sushi Combination 3 rolls of your choice",
        dishes: [],
      },
    ],
  },
  lunch3: {
    titleHE: `עסקית ${PRICE.LUNCH_3} ₪`,
    descriptionHE: lunchDescriptionHE,

    titleEN: `Lunch ${PRICE.LUNCH_3} ₪`,
    descriptionEN: lunchDescriptionEN,

    types: [
      {
        titleHE: "מנה ראשונה",
        descriptionHE: "",
        titleEN: "FIRST COURSE",
        descriptionEN: "",
        dishes: [],
      },
      {
        titleHE: "מנה עיקרית מהמטבח ",
        descriptionHE: "",
        titleEN: "MAIN COURSE. KITCHEN",
        descriptionEN: "",
        dishes: [],
      },
      {
        titleHE: "מנה עיקרית סושי ",
        descriptionHE: "4 פריטים לבחירה (פריט אחד מכל קבוצה)",
        titleEN: "MAIN COURSE. SUSHI",
        descriptionEN:
          "Sushi Combination. 4 items of your choice - one item per section",
        dishes: [],
      },
    ],
  },
  wine: [
    {
      titleHE: "יין בכוסות",
      descriptionHE: "",

      titleEN: "WINE BY THE GLASS",
      descriptionEN: "",

      dishes: [],
      types: [
        {
          titleHE: "לבן",
          titleEN: "White",
          dishes: [],
        },
        {
          titleHE: "מבעבע ורוזה",
          titleEN: "Sparkling & Rose",
          dishes: [],
        },
        {
          titleHE: "אדום",
          titleEN: "Red",
          dishes: [],
        },
      ],
    },
    {
      titleHE: "יין בבקבוק",
      descriptionHE: "",

      titleEN: "WINE BY THE BOTTLE",
      descriptionEN: "",

      dishes: [],
      types: [
        {
          titleHE: "לבן",
          titleEN: "White",
          dishes: [],
        },
        {
          titleHE: "מבעבע ורוזה",
          titleEN: "Sparkling & Rose",
          dishes: [],
        },
        {
          titleHE: "אדום",
          titleEN: "Red",
          dishes: [],
        },
      ],
    },
    {
      titleHE: "יינות מתיישנים",
      descriptionHE: "",

      titleEN: "FROM THE CELLAR",
      descriptionEN: "",

      dishes: [],
    },
  ],
  sake: [
    {
      titleHE: "בירות",
      descriptionHE: "",

      titleEN: "BEER",
      descriptionEN: "",

      dishes: [],
    },
    {
      titleHE: "סאקה ואומשו",
      descriptionHE: "",

      titleEN: "UMESHU & SAKE",
      descriptionEN: "",

      dishes: [],
    },
  ],
  cocktails: {
    titleHE: "קוקטיילים",
    descriptionHE: "",

    titleEN: "Coctails",
    descriptionEN: "",

    dishes: [],
  },
  softDrinks: {
    titleHE: "שתייה קלה",
    descriptionHE: "",

    titleEN: "Soft Drinks",
    descriptionEN: "",

    dishes: [],
  },
  spirits: {
    titleHE: "אלכוהול",
    descriptionHE: "",

    titleEN: "Spirits",
    descriptionEN: "",

    types: [
      {
        titleHE: "אפריטיף",
        titleEN: "Aperitif",
        dishes: [],
      },
      {
        titleHE: "וודקה",
        titleEN: "Vodka",
        dishes: [],
      },
      {
        titleHE: "רום",
        titleEN: "Rum",
        dishes: [],
      },
      {
        titleHE: "ג'ין",
        titleEN: "Gin",
        dishes: [],
      },
      {
        titleHE: "טקילה",
        titleEN: "Tequila",
        dishes: [],
      },
      {
        titleHE: "אניס",
        titleEN: "Anise",
        dishes: [],
      },
      {
        titleHE: "קוניאק",
        titleEN: "Cognac",
        dishes: [],
      },
      {
        titleHE: "ליקרים",
        titleEN: "Liqueur",
        dishes: [],
      },
      {
        titleHE: "דיז'סטיף",
        titleEN: "Dejestiv",
        dishes: [],
      },
      {
        titleHE: "ויסקי בלנדד",
        titleEN: "Blended Whisky",
        dishes: [],
      },
      {
        titleHE: "ויסקי אמריקאי",
        titleEN: "American Whiskey",
        dishes: [],
      },
      {
        titleHE: "ויסקי סינגל מאלט",
        titleEN: "Whisky Malt Single",
        dishes: [],
      },
      {
        titleHE: "ויסקי יפני",
        titleEN: "Japanese Whisky",
        dishes: [],
      },
    ],
    dishes: [],
  },
  favorites: [],
};

// Adding skewers to appetizers
state.appetizers.push(state.skewers);

// Adding menus to favorites
state.favorites.push(
  state.specials,
  state.appetizers[0],
  state.appetizers[1],
  state.skewers,
  state.mainDishes,
  state.desserts[0],
  state.seshimi[0],
  state.seshimi[1],
  state.inari[0],
  state.inari[1],
  state.hosomaki[0],
  state.temaki,
  state.irodori[0],
  state.wine[0],
  state.wine[1],
  state.wine[2],
  state.sake[0],
  state.sake[1],
  state.cocktails,
  state.spirits
);

export const map = {
  coldAppetiser: state.appetizers[0],
  hotAppetiser: state.appetizers[1],
  skewer: state.skewers,
  mainDishe: state.mainDishes,
  dessert: state.desserts[0],
  coffee: state.desserts[1],
  teaInfusion: state.desserts[2],
  tea: state.desserts[3],
  port: state.desserts[4],
  seshimiNigiri: state.seshimi[0],
  seshimiSpecial: state.seshimi[1],
  inariGunkan: state.inari[0],
  inariSpecial: state.inari[1],
  hosomaki: state.hosomaki[0],
  hosomakiIngredient: state.hosomaki[1],
  temaki: state.temaki,
  irodori: state.irodori[0],
  irodoriIngredient: state.irodori[1],
  cocktail: state.cocktails,
  beer: state.sake[0],
  sake: state.sake[1],
  softDrink: state.softDrinks,
  spirit: state.spirits,
  wineGlass: state.wine[0],
  wineBottle: state.wine[1],
  wineCellar: state.wine[2],
  special: state.specials,
  lunch: state.lunch,
};

export class Dish {
  constructor({
    titleHE,
    descriptionHE,
    titleEN,
    descriptionEN,
    price,
    isVegi,
    type,
    vintage,
    isActive,
    isSpecial,
    category,
    id,
  }) {
    this.id = id;
    this.titleHE = titleHE || "";
    this.descriptionHE = descriptionHE || "";
    this.titleEN = titleEN || "";
    this.descriptionEN = descriptionEN || "";
    this.price = price || 0;
    this.isVegi = isVegi;
    this.isActive = isActive;
    this.category = category || "global";
    this.updated = true;
    this.createDate = new Date();
    this.isSpecial = isSpecial;
    if (vintage) this.vintage = vintage;
    if (type || type === 0) this.type = type;
    menuList[this.id] = this;
  }
}

export const genId = (title, category) =>
  title.toLowerCase().replaceAll(" ", "_") + "_" + category;

// LUNCH
const createLunch = () => {
  const lunchSushiTypeNigiri = {
    titleHE: "ניגירי (זוג):",
    titleEN: "Nigiri (a pair):",
    isTypeTitle: true,
  };
  const lunchSushiTypeSeshimi = {
    titleHE: "סשימי (מנת סשימי כוללת 2 פרוסות):",
    titleEN: "Sashimi (2 slices):",
    isTypeTitle: true,
  };
  const lunchSushiTypeIrodori = {
    titleHE: "אירודורי רול (I/O חתוך ל-6):",
    titleEN: "I/O Irodori Roll (cut into 6):",
    isTypeTitle: true,
  };
  const lunchSushiTypeHosomaki = {
    titleHE: "הוסומאקי (חתוך ל-8):",
    titleEN: "Hosomaki (cut into 8):",
    isTypeTitle: true,
  };
  const lunchSushiTypeTemaki = {
    titleHE: "טמאקי - קונוס:",
    titleEN: "Temaki - Hand Rol:",
    isTypeTitle: true,
  };
  const lunchSushiTypeGunkan = {
    titleHE: "גונקן- כדור אורז עטוף אצה:",
    titleEN: "Gunkan - Rice ball wrapped with Nori:",
    isTypeTitle: true,
  };

  state.lunch1.types[0].dishes = [
    menuList.omiso_shiru,
    menuList.harusame_salad,
    menuList.toro_banbanji_coldAppetiser,
    menuList.wakame_salad_coldAppetiser,
    menuList.root_vegetables_salad,
    menuList.ebi_furai,
    menuList.agedashi_doufu,
    menuList.sakemori_roll,
  ];
  state.lunch1.types[1].dishes = [
    menuList.yaki_tofu_mainDishe,
    menuList.yasai_curry_rice,
    menuList.yasai_kare_udon,
    menuList.ingen_doufu,
    menuList.yasai_udon,
  ];
  state.lunch1.types[2].dishes = [
    menuList.midori_roll,
    menuList.yasai_cocktail_roll,
    menuList.vegetarian_mix_maki,
    menuList.shiitake_maki,
    menuList.aspara_maki,
    menuList.kanpyo_tamago_maki,
  ];

  state.lunch2.types[0].dishes = state.lunch1.types[0].dishes;
  state.lunch2.types[1].dishes = [
    menuList.tori_curry_rice,
    menuList.shiromi_donlunch,
    menuList.tori_kare_udon,
    menuList.wakadori_grill,
    menuList.yakiniku_lousujyu,
    menuList.tori_ramen,
    menuList.suzuki_agedashi,
    menuList.tori_ranmam_noodles_lunch,
  ];
  state.lunch2.types[2].dishes = [
    menuList.negi_shiro_zakana_maki,
    menuList.california_maki,
    menuList.bora_maki,
    menuList.sakemori_roll,
    menuList.ebikyu_roll,
    menuList.shiroguchi_roll_lunch,
    menuList.katsuo_roll_lunch,
    menuList.kaisen_cocktail_maki,
  ];

  state.lunch3.types[0].dishes = [
    ...state.lunch1.types[0].dishes,
    menuList.ebi_tempura,
  ];
  state.lunch3.types[1].dishes = [
    menuList.gyu_yaki_miso_lunch,
    menuList.kaisen_curry_rice,
    menuList.kaisen_shouga_itame,
    menuList.kaisen_udon,
    menuList.zakana_chirashi,
    menuList.sake_steak,
    menuList.kurodai_sugatayaki,
    menuList.shiroguchi_sogatayaki_mainDishe,
  ];
  state.lunch3.types[2].dishes = [
    lunchSushiTypeNigiri,
    menuList.sake,
    menuList.beni_toro,
    menuList.kurodai,
    menuList.suzuki,
    menuList.bora,
    menuList.shiroguchi,
    menuList.tamago,
    menuList.ebi,
    menuList.spanish_mackerel_seshimiNigiri,
    menuList.katsuo_seshimiNigiri,

    lunchSushiTypeSeshimi,
    menuList.sake,
    menuList.beni_toro,
    menuList.kurodai,
    menuList.suzuki,
    menuList.bora,
    menuList.shiroguchi,
    menuList.tamago,
    menuList.ebi,
    menuList.spanish_mackerel_seshimiNigiri,
    menuList.katsuo_seshimiNigiri,

    lunchSushiTypeIrodori,
    menuList.california_roll,
    menuList.spicy_tekka_roll,
    menuList.ebikyu_roll,
    menuList.sakemori_roll,

    lunchSushiTypeHosomaki,
    menuList.negi_shiro_zakana_maki,
    menuList.california_maki,
    menuList.hokkai_maki,
    menuList.ebi_sakekawa_maki,

    lunchSushiTypeTemaki,
    menuList.california_temaki,
    menuList.negi_shiro_zakana_temaki,
    menuList.ebi_sakekawa_temaki,
    menuList.kaisen_cocktail_temaki,

    lunchSushiTypeGunkan,
    menuList.kaisen_cocktail,
    menuList.sake_mix,
    menuList.shiro_zakana_mix,
  ];
};

// COMBINATIONS
const createCombitanions = () => {
  const combiTypeGunkan = { HE: "גונקן", EN: "Gunkan" };
  const combiTypeNigiri = { HE: "ניגירי", EN: "Nigiri" };

  state.combinations.types[0].dishes = [
    [
      menuList.inari_special_vegetarian,
      { HE: "2&nbspיח'", EN: "2&nbsppieces" },
    ],
    [menuList.yasai_cocktail_roll, { HE: "6&nbspיח'", EN: "6&nbsppieces" }],
    [
      menuList.tamago,
      { HE: "2&nbspיח'", EN: "2&nbsppieces", type: combiTypeNigiri },
    ],
    [menuList.midori_roll, { HE: "6&nbspיח'", EN: "6&nbsppieces" }],
    [menuList.kanpyo_tamago_maki, { HE: "8&nbspיח'", EN: "8&nbsppieces" }],
  ];

  state.combinations.types[1].dishes = [
    [menuList.inari_special_sake, { HE: "2&nbspיח'", EN: "2&nbsppieces" }],
    [menuList.tekkamago_roll_irodori, { HE: "6&nbspיח'", EN: "6&nbsppieces" }],
    [
      menuList.kurodai,
      { HE: "2&nbspיח'", EN: "2&nbsppieces", type: combiTypeNigiri },
    ],
    [menuList.shiro_zakana_roll, { HE: "6&nbspיח'", EN: "6&nbsppieces" }],
    [menuList.spicy_tekka_maki, { HE: "8&nbspיח'", EN: "8&nbsppieces" }],
  ];

  state.combinations.types[2].dishes = [
    [menuList.inari_special_kuruma, { HE: "2&nbspיח'", EN: "2&nbsppieces" }],
    [
      menuList.yasai_sake_cocktail_roll_irodori,
      { HE: "6&nbspיח'", EN: "6&nbsppieces" },
    ],
    [
      menuList.maguro,
      { HE: "2&nbspיח'", EN: "2&nbsppieces", type: combiTypeNigiri },
    ],
    [menuList.hotate_tobiko_roll, { HE: "6&nbspיח'", EN: "6&nbsppieces" }],
    [menuList.hokkai_maki, { HE: "8&nbspיח'", EN: "8&nbsppieces" }],
  ];
};

export const inputTypes = {
  categories: [
    ["special", "ספיישלים"],
    ["coldAppetiser", "ראשונות קרות"],
    ["hotAppetiser", "ראשונות חמות"],
    ["skewer", "שיפודי עץ על הגריל"],
    ["mainDishe", "מנות עיקריות"],
    ["dessert", "קינוחים"],
    ["coffee", "קפה"],
    ["teaInfusion", "תה חליטה"],
    ["tea", "תיונים"],
    ["port", "פורט & שרי"],
    ["seshimiNigiri", "סשימי / ניגירי"],
    ["seshimiSpecial", "סשימי ספיישל"],
    ["inariGunkan", "אינרי / גונקן"],
    ["inariSpecial", "אינארי ספיישל"],
    ["hosomaki", "הוסומקי"],
    ["hosomakiIngredient", "תוספות אפשריות למאקי"],
    ["temaki", "טמקי - קונוס"],
    ["irodori", "אירודורי"],
    ["irodoriIngredient", "תוספות אפשריות בחוץ"],
    ["wineGlass", "יין בכוסות"],
    ["wineBottle", "יין בבקבוק"],
    ["wineCellar", "יינות מתיישנים"],
    ["beer", "בירות"],
    ["sake", "סאקה ואומשו"],
    ["cocktail", "קוקטיילים"],
    ["softDrink", "שתייה קלה"],
    ["spirit", "אלכוהול"],
    ["lunch", "רק בעסקיות"],
  ],
  special: [
    [0, "מנה"],
    [1, "קינוח"],
    [2, "קוקטייל"],
    [3, "יין"],
  ],
  seshimiNigiri: [
    [0, "דגי ים"],
    [1, "מים תתוקים"],
    [2, "פירוט ים"],
    [3, "שונות"],
    [4, "רק בעונה"],
  ],
  wine: [
    [0, "לבן"],
    [1, "רוזה"],
    [2, "אדום"],
  ],
  spirit: [
    ["0", "אפריטיף"],

    ["1", "וודקה"],

    ["2", "רום"],

    ["3", "ג'ין"],

    ["4", "טקילה"],

    ["5", "אניס"],

    ["6", "קוניאק"],

    ["7", "ליקרים"],

    ["8", "דיז'סטיף"],

    ["9", "ויסקי בלנדד"],

    ["10", "ויסקי אמריקאי"],

    ["11", "ויסקי סינגל מאלט"],

    ["12", "ויסקי יפני"],
  ],
};

export const getMenu = async (all = false) => {
  try {
    const data = JSON.parse(await AJAX(`${SERVER_URL}${all ? "?all=1" : ""}`));
    config = data.config;
    config.activeMenuItems = new Set(config.activeMenuItems);
    delete config._id;
    data.menu.forEach(dish => {
      menuList[dish.id] = dish;
      delete menuList[dish.id]._id;
    });

    pushDishesToState();
    return menuList;
  } catch (err) {
    console.error(`${err} 💥💥💥💥`);
    throw err;
  }
};
